export const ADD_UPLOAD = "uploads/ADD_UPLOAD";
export const REMOVE_UPLOAD = "uploads/REMOVE_UPLOAD";
export const UPDATE_PROGRESS = "uploads/UPDATE_PROGRESS";
export const POPULATE_INITIAL = "uploads/POPULATE_INITIAL";
